/*******************************************************************************************************
 **                                                                                                    **
 **                                             VARIABLES                                              **
 **                                                                                                    **
 *******************************************************************************************************/

const addToCartButtonLibrary = document.querySelector(".add-to-cart");
const addToCartForUnpaintedLibrary = document.querySelector(
	".add-to-cart-for-unpainted",
);
const addToCartStickyLibrary = document.querySelector(".sticky-add-to-cart");
const checkboxGetPaintCodeWithVINAndLabel = document
	.querySelector("input#checkbox-get-paint-code-with-vin")
	?.closest("label");
const checkboxUnpainted = document.getElementById("checkbox-select-unpainted");
const checkboxPaintOptions = document.getElementById(
	"checkbox-select-paint-option",
);
const fakeCheckboxCircle = document.getElementById(
	"fake-checkbox-get-paint-code-with-license-or-vin",
);

const checkboxGetPaintCodeWithLicenseAndLabel = document
	.querySelector("input#checkbox-get-paint-code-with-license")
	?.closest("label");
const colorBox = document.getElementById("color-preview-box");
const colorPreviewContainerLibrary = document.querySelector(
	".color-preview-container-for-customizations",
);
const colorPreviewTitle = document.querySelector(".color-preview-title");
const colorPreviewWrapper = document.getElementById("color-preview-wrapper");
const colorSkeleton = document.getElementById("color-preview-skeleton");
const combinedVariantSelectLibrary =
	document.getElementById("variant-selector");
const fitmentDescriptionContainerLibrary = document.querySelector(
	".fitment-description-container",
);
const form = document.getElementById("product-form");
const getPaintCodeUsingVinLibrary = document.querySelector(
	".get-paint-code-using-vin",
);
const giveUsYourVinMsgLibrary = document.querySelector(".give-us-your-vin-msg");
const howToFindPaintCodeBtnLibrary = document.getElementById(
	"how-to-find-your-paint-code-vindecoder",
);
// const notCompatibleMsgLibrary = document.querySelector('.not-compatible-msg');
const oemVinContainerLibrary = document.querySelector(".oem-vin-container");
const paintedStockKeyPaintLevelLibrary = document.querySelector(
	".painted-stock-key-paint-level",
);
const paintedStockKeyQualityLevelLibrary = document.querySelector(
	".painted-stock-key-quality-level",
);
const paintCodeAppContainerLibrary = document.getElementById(
	"paintcode-app-container",
);
const paintCodeAppContainerLicenseLibrary = document.getElementById(
	"paintcode-app-container-license",
);
const paintCodeWrapperLibrary = document.querySelector(".paint-code-wrapper");
const paintOptionCheckboxByPaintCode = document.getElementById(
	"checkbox-select-paint-option",
);
const paintOptionCheckboxByUnpainted = document.getElementById(
	"checkbox-select-unpainted",
);
const paintOptionCheckboxByVIN = document.getElementById(
	"checkbox-get-paint-code-with-vin",
);
const paintOptionCheckboxByLicense = document.getElementById(
	"checkbox-get-paint-code-with-license",
);
const paintOptionFakeCheckbox = document.getElementById(
	"fake-checkbox-get-paint-code-with-license-or-vin",
);
const paintOptionCheckboxStoredCode = document.getElementById(
	"checkbox-paint-code-local-storage",
);
const paintOptionsCheckboxGroupLibrary = document.querySelector(
	".paint-options-checkbox-group",
);
const precisionMatchContainerLibrary = document.querySelector(
	".precision-match-container",
);
const precisionMatchCheckboxYes = document.getElementById("precision-match");
const precisionMatchCheckboxNo = document.getElementById("standard-match");
const precisionMatchButton = document.getElementById("precision-match-button");
const precisionMatchInputBox = document.getElementById(
	"precision-match-textbox",
);
const precisionMatchVinWrapper = document.getElementById(
	"precision-match-textbox-wrapper",
);
const priceContainerLargeScreen = document.querySelector(
	".price-container-large-screen",
);
const priceContainerSmallScreen = document.querySelector(".price-container");
const priceDisplay = document.getElementById("price-display");
const productPartDescriptionLibrary = document.querySelector(
	".product-description-collapsible-text",
);
const qualityTypeSelectLibrary = document.getElementById("quality-type-select");
const qualityOptionsCheckboxLibrary = document.querySelectorAll(
	".quality-options-checkbox",
);
const qualityOptionsInStockBadges = document.querySelectorAll(
	".quality-in-stock-badge",
);
const qualityOptionsOOSBadges = document.querySelectorAll(".quality-oos-badge");
const qualityDescriptionBtnLibrary = document.getElementById(
	"quality-description-vindecoder",
);
const selectVinVariantButtonLibrary =
	document.getElementById("select-vin-variant");
const storedDecodedPaintCodeMsgLibrary = document.querySelector(
	".stored-decoded-paint-msg",
);
const selectCodeFailSafeLibrary = document.querySelector(
	".select-code-fail-safe",
);
const titleElementLibrary = document.querySelector(".product-title");
// const vinTextBoxOEMLibrary = document.getElementById("vin-textbox-for-oem");
const vinVerificationCheckboxGroupLibrary = document.querySelector(
	".vin-verification-checkbox-group",
);
const vinVerifyCheckbboxYesLibrary = document.getElementById("fitment-yes");
const vinVerifyCheckboxNoLibrary = document.getElementById("fitment-no");
const vinVerificationButtonLibrary = document.getElementById(
	"vin-verification-button",
);
const vinVerificationWrapper = document.getElementById(
	"vin-textbox-for-verification-wrapper show",
);
const vinVerificationInput = document.getElementById(
	"vin-textbox-for-verification",
);

// const vinAfterSelection = document.getElementById(
// 	"vin-after-paint-code-selection"
// );

const licenseLabel = document.getElementById("paint-code-license-option");
const vinLabel = document.getElementById("paint-code-vin-option");
const separator = document.getElementById("vin-license-separator");

let emptyVinVerificationRadioButtons = true;
let emptyPrecisionMatchRadioButtons = true;
let boolMatchByVIN = false;
let selectedOptionHasAvailableStock = false;
let failedVinDecode = false;
let vinDecoderJustUsed = false;
// isVinDecoderExhausted: This is used to determine if the VIN decoder has been exhausted, meaning no more attempts can be made.
let isVinDecoderExhausted = false;
let isLicenseDecoderExhausted = false;
let addedBadgeInPaintOptions = false;
let selectedVariantUnavailable = false;
let matchingByVin = false;
let aftermarketAvailability = "";
let capaAvailability = "";
let oemAvailability = "";
let storedVin = "";
let selectedProductSku = "";
let selectedProductColor = "";
let selectedProductTitle = "";
let selectedProductType = "";
let paintOptionMsgFindByVin = "";
let paintOptionMsgFindByLicense = "";
let paintOptionMsgShortFindByLicense = "";
let paintOptionMsgShortFindByVin = "";
window.productVariants = {};
let fitmentQuestionScrollPosition = {};
let amountOfVINPostMessages = 0;
let amountOfOOSPaintVariants = 0;
let currentAddToCartBtnLibrary;
let isOnlyOEM = false;
if (addToCartButtonLibrary) {
	currentAddToCartBtnLibrary = addToCartButtonLibrary;
}
if (addToCartForUnpaintedLibrary) {
	currentAddToCartBtnLibrary = addToCartForUnpaintedLibrary;
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                             ENABLE/DISABLE                                         **
 **                                                                                                    **
 *******************************************************************************************************/
// Toggling

// DISABLING AND CLEARING
function hideFitmentFailButton() {
	// Must defined the element here as it is dynamically created
	const fitmentFailButtonLibrary = document.getElementById(
		"fitment-fail-button",
	);

	if (fitmentFailButtonLibrary) fitmentFailButtonLibrary.style.display = "none";
}

function clearQualityTypeSelect() {
	if (qualityOptionsCheckboxLibrary) {
		const qualityRadioButtons = document.querySelectorAll(
			'input[name="quality_type"]',
		);
		qualityRadioButtons.forEach((radio) => (radio.checked = false));
	} else {
		if (qualityTypeSelectLibrary) qualityTypeSelectLibrary.selectedIndex = 0;
	}
}

function clearAndHidePaintOptionSelect(
	event,
	isCallFromVinInput,
	isCallFromSelectPaintCode,
) {
	const vinElements = getVisibleVinDecoderElements();
	if (vinElements) {
		if (vinElements.input) {
			vinElements.input.value = "";
			//vinElements.input.focus();
		}
		if (vinElements.submitBtn) {
			vinElements.submitBtn.disabled = true;
		}
	}

	if (isCallFromVinInput) {
		// Called from VIN input - only clear VIN, keep wrapper visible
		event.preventDefault();
		if (event.target && event.target.value !== undefined) {
			event.target.value = "";
		}
		// vinElements.input.focus();

		// Sync the fake circle for VIN option
		paintOptionCheckboxByVIN.checked = true;
		syncFakeCircle();

		hideVinInputAfterSelection();
	} else if (isCallFromSelectPaintCode) {
		// Called from Select Paint Code - hide VIN input, label, and color preview
		vinElements.input.value = "";
		hideColorPreviewContainer();

		// since the paintcode wrapper is hide from vinSubmitBtn click
		// need to show and repull paint option here
		showPaintCodeWrapper();

		// Keep the paint code selection as is
		checkboxPaintOptions.checked = true;
	} else {
		// Called from License Plate - clear license plate inputs
		const stateSelect = document.getElementById("license-decoder-state-select");
		const licenseDecoderPlateInput = document.getElementById(
			"license-decoder-plate-input",
		);
		const licenseDecoderSubmitBtn = document.querySelector(
			".license-decoder-submit-btn",
		);
		if (stateSelect) {
			stateSelect.selectedIndex = 0;
		}
		if (licenseDecoderPlateInput) {
			licenseDecoderPlateInput.value = "";
		}
		if (licenseDecoderSubmitBtn) {
			licenseDecoderSubmitBtn.disabled = true;
		}
		paintOptionCheckboxByLicense.checked = true;

		// Hide color preview when clearing license
		hideColorPreviewContainer();
	}
}

function disablePrePaintedMessagingQualityLevel() {
	if (paintedStockKeyQualityLevelLibrary) {
		paintedStockKeyQualityLevelLibrary.classList.add("disabled");
	}
}

function disableFitmentSelect() {
	const additionalOptionsTitle = document.querySelector(
		".additional-options-title",
	);
	const fitmentRadioButtons = document.querySelectorAll(".fitment-radio");
	const fitmentDescriptionContainer = document.querySelector(
		".fitment-description-container",
	);

	if (fitmentRadioButtons.length > 0) {
		fitmentRadioButtons.forEach((radio) => {
			if (radio) {
				radio.disabled = true;
				radio.checked = false;
			}
		});
	}
	const fitmentTexts = document.querySelectorAll(".fitmentText");
	if (fitmentTexts.length > 0) {
		fitmentTexts.forEach(function (el) {
			if (el) {
				el.classList.add("fitment-disabled");
				el.style.color = "#ccc";
			}
		});
	}
	const fitmentTypeSelects = document.querySelectorAll(".fitment-type-select");
	if (fitmentTypeSelects.length > 0) {
		fitmentTypeSelects.forEach(function (el) {
			if (el) {
				el.classList.add("fitment-disabled");
			}

			if (fitmentDescriptionContainerLibrary) {
				const firstFitmentQuestionButton = document.getElementById(
					`fitment-button-description-${el.dataset.groupIndex}`,
				);
				if (firstFitmentQuestionButton) {
					firstFitmentQuestionButton.disabled = true;
				}
			}
		});
	}
	if (additionalOptionsTitle) {
		additionalOptionsTitle.classList.add("additional-options-title-disabled");
		additionalOptionsTitle.style.color = "#ccc";
	}
	// Disable the nearest button to fitmentDescriptionContainer
	if (fitmentDescriptionContainer) {
		const nearestButton =
			fitmentDescriptionContainer.querySelector("button") ||
			fitmentDescriptionContainer.closest("button") ||
			fitmentDescriptionContainer.parentElement.querySelector("button");
		if (nearestButton) {
			nearestButton.disabled = true;
		}
	}

	// hard-disable all radios/selects in the Additional Compatibility block
	if (fitmentDescriptionContainerLibrary) {
		const compatContainer = fitmentDescriptionContainerLibrary.parentElement;
		if (compatContainer) {
			const compatInputs = compatContainer.querySelectorAll(
				'input[type="radio"], select',
			);
			compatInputs.forEach((el) => {
				el.disabled = true;
				el.classList.add("fitment-disabled");
			});
		}
	}
}

function hideNotCompatibleMsg() {
	const notCompatibleMsgLibrary = document.querySelector(".not-compatible-msg");
	if (notCompatibleMsgLibrary) notCompatibleMsgLibrary.style.display = "none";
}

function disableQualityTypeSelect() {
	if (qualityOptionsCheckboxLibrary) {
		const qualityRadioButtons = document.querySelectorAll(
			'input[name="quality_type"]',
		);

		// If quality options checkboxes
		qualityRadioButtons.forEach((radio) => {
			radio.disabled = true;
		});
	}

	// If quality select dropdown
	clearQualityTypeSelect();
	if (qualityTypeSelectLibrary) qualityTypeSelectLibrary.disabled = true;

	if (qualityOptionsInStockBadges) {
		qualityOptionsInStockBadges.forEach(function (badge) {
			badge.classList.add("disabled");
		});
	}
	if (qualityOptionsOOSBadges) {
		qualityOptionsOOSBadges.forEach(function (badge) {
			badge.classList.add("disabled");
		});
	}
}

function disableQualityDescriptionBtn() {
	if (qualityDescriptionBtnLibrary)
		qualityDescriptionBtnLibrary.disabled = true;
}

// function disableVINTextboxForOEM() {
// 	if (vinTextBoxOEMLibrary) {
// 		vinTextBoxOEMLibrary.value = "";
// 		vinTextBoxOEMLibrary.disabled = true;
// 	}
// }

// function hideVINTextboxForOEM() {
// 	if (
// 		oemVinContainerLibrary &&
// 		oemVinContainerLibrary.classList.contains("show")
// 	)
// 		oemVinContainerLibrary.classList.remove("show");
// }

function hidePaintCodeWrapper() {
	if (
		paintCodeWrapperLibrary &&
		paintCodeWrapperLibrary.classList.contains("show")
	) {
		paintCodeWrapperLibrary.classList.remove("show");
	}
}

function disableCombinedVariantSelect() {
	if (combinedVariantSelectLibrary)
		combinedVariantSelectLibrary.disabled = true;
}
function clearCombinedVariantSelect() {
	if (combinedVariantSelectLibrary)
		combinedVariantSelectLibrary.selectedIndex = 0;
}

function disableStoredPaintCodeMsg() {
	if (storedDecodedPaintCodeMsgLibrary)
		storedDecodedPaintCodeMsgLibrary.classList.add("disabled");
}

function disableGiveUsVinMsg() {
	if (giveUsYourVinMsgLibrary)
		giveUsYourVinMsgLibrary.classList.add("disabled");
}

function disablePaintOptionRadioBtns() {
	if (paintOptionCheckboxByUnpainted)
		paintOptionCheckboxByUnpainted.disabled = true;
	if (paintOptionCheckboxByPaintCode) {
		paintOptionCheckboxByPaintCode.disabled = true;
		hidePaintCodeWrapper();
		if (
			paintCodeAppContainerLibrary &&
			paintCodeAppContainerLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLibrary.classList.remove("show");
		}
		if (
			paintCodeAppContainerLicenseLibrary &&
			paintCodeAppContainerLicenseLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLicenseLibrary.classList.remove("show");
		}
	}
	if (paintOptionCheckboxByVIN) paintOptionCheckboxByVIN.disabled = true;
	if (paintOptionCheckboxByLicense)
		paintOptionCheckboxByLicense.disabled = true;
	if (paintOptionFakeCheckbox) paintOptionFakeCheckbox.disabled = true;
	if (paintOptionCheckboxStoredCode)
		paintOptionCheckboxStoredCode.disabled = true;
	if (selectCodeFailSafeLibrary) selectCodeFailSafeLibrary.disabled = true;
}

function resetPaintOptionRadioBtns() {
	storedVin = "";
	const storedOptionLabel = document.getElementById("paint-code-stored-option");
	const selectPaintCodeOption = document.getElementById(
		"paint-code-select-code-option",
	);
	const vinErrorMsgContainer = document.querySelector(
		".vin-error-message-container",
	);
	if (storedOptionLabel) storedOptionLabel.style.display = "none";
	if (window.DISPLAY_PAINT_CODE_RADIO_OPTION) {
		if (selectCodeFailSafeLibrary) {
			selectCodeFailSafeLibrary.style.display = "none";
		}
	}
	if (selectPaintCodeOption && selectPaintCodeOption.style.display === "none") {
		selectPaintCodeOption.style.display = "block";
	}
	if (vinErrorMsgContainer) {
		vinErrorMsgContainer.style.display = "none";
	}
}

function hidePaintCodeAppContainer(toggleDisplay) {
	// If 'Use VIN' or "Use License Plate" is selected
	if (toggleDisplay) {
		// First check to see if the opposite container is shown (in this case, the license container)
		if (
			paintCodeAppContainerLicenseLibrary &&
			(paintCodeAppContainerLicenseLibrary.style.display === "none" ||
				paintCodeAppContainerLicenseLibrary.style.display === "")
		) {
			// If the license container is shown, hide it (this is to bypass the slide animation)
			paintCodeAppContainerLibrary.style.display = "none";
			paintCodeAppContainerLicenseLibrary.style.display = "block";
			if (
				!paintCodeAppContainerLicenseLibrary.classList.contains("show") &&
				!isLicenseDecoderExhausted
			) {
				paintCodeAppContainerLicenseLibrary.classList.add("show");
			}
		} else {
			// If 'Use Vin' or "Use License Plate" is selected, hide the paint code app container
			if (
				paintCodeAppContainerLibrary &&
				paintCodeAppContainerLibrary.classList.contains("show")
			) {
				paintCodeAppContainerLibrary.classList.remove("show");
			}
		}
	} else {
		// If 'Use VIN' or "Use License Plate" is not selected, remove the 'show' class for the animation
		if (
			paintCodeAppContainerLibrary &&
			paintCodeAppContainerLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLibrary.classList.remove("show");
		}

		// Reset the display properties
		if (
			paintCodeAppContainerLibrary &&
			paintCodeAppContainerLibrary.style.display !== ""
		) {
			paintCodeAppContainerLibrary.style.display = "";
		}
		if (
			paintCodeAppContainerLicenseLibrary &&
			paintCodeAppContainerLicenseLibrary.style.display !== ""
		) {
			paintCodeAppContainerLicenseLibrary.style.display = "";
		}
	}
}

function hidePaintCodeAppContainerLicense(
	toggleDisplay,
	toggleOppositeContainer,
) {
	// If 'Use VIN' or "Use License Plate" is selected
	if (toggleDisplay) {
		// First check to see if the opposite container is shown (in this case, the VIN container)
		if (
			paintCodeAppContainerLibrary &&
			(paintCodeAppContainerLibrary.style.display === "none" ||
				paintCodeAppContainerLibrary.style.display === "")
		) {
			// If the VIN container is shown, hide it (this is to bypass the slide animation)
			paintCodeAppContainerLicenseLibrary.style.display = "none";
			if (toggleOppositeContainer) {
				paintCodeAppContainerLibrary.style.display = "block";
			} else {
				paintCodeAppContainerLibrary.style.display = "none";
			}
			if (
				!paintCodeAppContainerLibrary.classList.contains("show") &&
				!isVinDecoderExhausted
			) {
				paintCodeAppContainerLibrary.classList.add("show");
			}
		} else {
			// If 'Use VIN' or "Use License Plate" is selected, hide the paint code app container license
			if (
				paintCodeAppContainerLicenseLibrary &&
				paintCodeAppContainerLicenseLibrary.classList.contains("show")
			) {
				paintCodeAppContainerLicenseLibrary.classList.remove("show");
			}
		}
	} else {
		// If 'Use VIN' or "Use License Plate" is not selected, remove the 'show' class for the animation
		if (
			paintCodeAppContainerLicenseLibrary &&
			paintCodeAppContainerLicenseLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLicenseLibrary.classList.remove("show");
		}

		// Reset the display properties
		if (
			paintCodeAppContainerLicenseLibrary &&
			paintCodeAppContainerLicenseLibrary.style.display !== ""
		) {
			paintCodeAppContainerLicenseLibrary.style.display = "";
		}
		if (
			paintCodeAppContainerLibrary &&
			paintCodeAppContainerLibrary.style.display !== ""
		) {
			paintCodeAppContainerLibrary.style.display = "";
		}
	}
}

function clearPaintOptionRadioBtns() {
	if (paintOptionsCheckboxGroupLibrary) {
		const radios = document.querySelectorAll(
			'input[name="select_paint_option"], input[name="fake_select_paint_option"]',
		);
		radios.forEach((radio) => (radio.checked = false));
	}
}

function syncFakeCircle() {
	if (fakeCheckboxCircle) {
		if (
			paintOptionCheckboxByVIN?.checked ||
			paintOptionCheckboxByLicense?.checked
		) {
			fakeCheckboxCircle.checked = true;
		} else if (checkboxUnpainted?.checked || checkboxPaintOptions?.checked) {
			fakeCheckboxCircle.checked = false;
		}

		fakeCheckboxCircle.disabled =
			paintOptionCheckboxByVIN?.disabled &&
			paintOptionCheckboxByLicense?.disabled;
	}
}

function hideGetPaintCodeUsingVINCheckbox() {
	if (checkboxGetPaintCodeWithVINAndLabel)
		checkboxGetPaintCodeWithVINAndLabel.style.display = "none";
	if (checkboxGetPaintCodeWithLicenseAndLabel)
		checkboxGetPaintCodeWithLicenseAndLabel.style.display = "none";
	if (checkboxGetPaintCodeFakeLabel)
		checkboxGetPaintCodeFakeLabel.style.display = "none";
}

function hidePaintedStockKeyPaintDisclaimer() {
	if (paintedStockKeyPaintLevelLibrary)
		paintedStockKeyPaintLevelLibrary.style.display = "none";
}

function hidePaintedStockKeyQualityDisclaimer() {
	if (paintedStockKeyQualityLevelLibrary)
		paintedStockKeyQualityLevelLibrary.style.display = "none";
}

function disablePaintedStockKeyQualityDisclaimer() {
	if (paintedStockKeyQualityLevelLibrary)
		paintedStockKeyQualityLevelLibrary.classList.add("disabled");
}

function hideVinMessageParagraph() {
	// const vinMessageParagraphLibrary = document.querySelector(
	// 	".vin-decoder-message"
	// );
	const vinMessageParagraphLibrary = document.querySelector(
		'[class^="vin-decoder-message"]:not([style*="display: none"])',
	);

	if (vinMessageParagraphLibrary) {
		vinMessageParagraphLibrary.style.display = "none";
	}
}

function hideLicenseMessageParagraph() {
	const licenseMessageParagraphLibrary = document.querySelector(
		".license-decoder-message",
	);

	if (licenseMessageParagraphLibrary) {
		licenseMessageParagraphLibrary.style.display = "none";
	}
}

function disablehowToFindPaintCodeBtn() {
	disableStoredPaintCodeMsg();
	disableGiveUsVinMsg();
	disablePaintOptionRadioBtns();
	if (howToFindPaintCodeBtnLibrary)
		howToFindPaintCodeBtnLibrary.disabled = true;
}

function disableGetPaintCodeUsingVin() {
	if (getPaintCodeUsingVinLibrary) getPaintCodeUsingVinLibrary.disabled = true;
}

function hideColorPreviewContainer() {
	if (
		colorPreviewContainerLibrary &&
		colorPreviewContainerLibrary.classList.contains("show")
	)
		colorPreviewContainerLibrary.classList.remove("show");
}

function disableSelectVinVariantBtn() {
	if (selectVinVariantButtonLibrary)
		selectVinVariantButtonLibrary.disabled = true;
}

function disablePrecisionMatchBtns() {
	if (precisionMatchContainerLibrary) precisionMatchCheckboxYes.disabled = true;
	if (precisionMatchContainerLibrary) precisionMatchCheckboxNo.disabled = true;
	if (precisionMatchButton) precisionMatchButton.disabled = true;
}

function clearPrecisionMatchRadioButtons() {
	if (precisionMatchContainerLibrary) {
		const radios = document.querySelectorAll(`input[name="precision_match"]`);
		radios.forEach((radio) => (radio.checked = false));
		precisionMatchVinWrapper.classList.remove("show");
		precisionMatchInputBox.value = "";
		emptyPrecisionMatchRadioButtons = true;
	}
}

function disableVinVerificationBtns() {
	if (vinVerifyCheckbboxYesLibrary)
		vinVerifyCheckbboxYesLibrary.disabled = true;
	if (vinVerifyCheckboxNoLibrary) vinVerifyCheckboxNoLibrary.disabled = true;
	if (vinVerificationButtonLibrary)
		vinVerificationButtonLibrary.disabled = true;
	if (vinVerificationInput) vinVerificationInput.disabled = true;
}

function clearVinVerificationRadioButtons() {
	if (vinVerificationCheckboxGroupLibrary) {
		const radios = document.querySelectorAll(`input[name="fitment_guarantee"]`);
		radios.forEach((radio) => (radio.checked = false));
		vinVerificationWrapper.classList.remove("show");
		// vinVerificationInput.value = '';
		emptyVinVerificationRadioButtons = true;
	}
}

function clearVinInput() {
	const vinDecoderInput = document.getElementById(
		"vin-decoder-textbox-for-verification-byvin",
	);
	const vinDecoderAfterPaintSelec = document.getElementById(
		"vin-decoder-textbox-for-verification-after",
	);
	if (vinDecoderInput) vinDecoderInput.value = "";
	if (vinDecoderAfterPaintSelec) vinDecoderAfterPaintSelec.value = "";
}

function hideOOSPaintVariantsMsg() {
	const oemUncertaintyLibrary = document.querySelector(".oem-uncertainty");
	if (oemUncertaintyLibrary && oemUncertaintyLibrary.classList.contains("show"))
		oemUncertaintyLibrary.classList.remove("show");
}

// only hide the label text now. // Add VIN for better match...
function hideVinInputAfterSelection() {
	const vinElements = getVisibleVinDecoderElements();
	if (vinElements) {
		if (
			vinElements.vinAfterSelection &&
			vinElements.vinAfterSelection.classList.contains("show")
		) {
			vinElements.vinAfterSelection.classList.remove("show");
		}
	}
}

// hide vin-input-label-and-textbox
function hideVinInputContainer() {
	const vinElements = getVisibleVinDecoderElements();
	if (vinElements) {
		if (
			vinElements.vinInputContainer &&
			vinElements.vinInputContainer.style.display === "block"
		) {
			vinElements.vinInputContainer.style.display = "none";
		}
		// if (vinElements.input) {
		// 	vinElements.input.required = false;
		// 	vinElements.input.value = "";
		// }

		syncVinRequiredWithPaintOption();
	}
}

function showVinInputContainer() {
	const vinElements = getVisibleVinDecoderElements();
	if (vinElements) {
		if (
			vinElements.vinInputContainer &&
			vinElements.vinInputContainer.style.display === "none"
		) {
			vinElements.vinInputContainer.style.display = "block";
		}
	}
}

// change to hide new vininput which inherited from find paint code by vin
function hideVinInputIfVinExist() {
	// const vinAfterSelectionInput = document.getElementById(
	// 	"vin-after-paint-code-textbox"
	// );

	const terms = window.getSearchTerms() || [];
	const existingVIN = (terms[0]?.vin || "").trim();
	// Must check to see if there is no existingViN AND if the class 'has-vin-on-file' already exists
	if (!existingVIN && document.body.classList.contains("has-vin-on-file")) {
		document.body.classList.remove("has-vin-on-file");
		return;
	}
	if (!existingVIN) return;

	document.body.classList.add("has-vin-on-file");

	// Make sure the field cannot block form submission
	// if (vinAfterSelectionInput) {
	// 	vinAfterSelectionInput.required = false;
	// 	vinAfterSelectionInput.value = existingVIN.toUpperCase(); // optional, if still want it captured as a property
	// }
	const vinElements = getVisibleVinDecoderElements();
	if (vinElements) {
		if (vinElements.input) {
			vinElements.input.required = false;
			vinElements.input.value = existingVIN.toUpperCase();
		}
	}
	hideVinInputAfterSelection();
	hideVinInputContainer();
}

function clearOOSPaintCheckbox() {
	const checkbox = document.querySelector(
		`input[name="acknowledge_oem_uncertainty"]`,
	);
	if (checkbox.checked === true) checkbox.checked = false;
}

function hideFitmentVerificationComponent(isBannedString) {
	const vinGuaranteeContainer = document.querySelector(
		".vin-guarantee-container",
	);
	if (
		vinGuaranteeContainer &&
		!vinGuaranteeContainer.classList.contains("hide")
	) {
		vinGuaranteeContainer.classList.add("hide");
	}
	if (isBannedString !== "") {
		enableOrDisableAddToCartForOEM(isBannedString);
	}
}

function hideVinVerificationTextbox() {
	if (
		vinVerificationWrapper &&
		vinVerificationWrapper.classList.contains("show")
	)
		vinVerificationWrapper.classList.remove("show");
}

function hideAddToCartButton() {
	if (currentAddToCartBtnLibrary)
		currentAddToCartBtnLibrary.style.display = "none";
}

function disableAddToCartButton() {
	if (currentAddToCartBtnLibrary) currentAddToCartBtnLibrary.disabled = true;
	if (addToCartStickyLibrary) addToCartStickyLibrary.disabled = true;
}

function enableAddButtonIfVinExist() {
	const activeCarVin = getSearchTerms()[0]?.vin;

	if (!activeCarVin) {
		disableAddToCartButton();
	} else {
		enableAddToCartButton();
	}
}

// ENABLING
function showFitmentFailButton() {
	// Must defined the element here as it is dynamically created
	const fitmentFailButtonLibrary = document.getElementById(
		"fitment-fail-button",
	);

	if (fitmentFailButtonLibrary)
		fitmentFailButtonLibrary.style.display = "block";
}

function enablePrePaintedMessagingQualityLevel() {
	if (paintedStockKeyQualityLevelLibrary) {
		paintedStockKeyQualityLevelLibrary.classList.remove("disabled");
	}
}

function enableProductTypeSelect() {
	if (qualityOptionsCheckboxLibrary) {
		const qualityRadioButtons = document.querySelectorAll(
			'input[name="quality_type"]',
		);
		const availableRadios = [];

		// If quality options checkboxes
		qualityRadioButtons.forEach((radio) => {
			const isUnavailableByDataset =
				radio.dataset.available === "false" ||
				radio.dataset.unavailable === "true" ||
				radio.getAttribute("data-unavailable") === "true";
			const isAvailable = !radio.disabled && !isUnavailableByDataset;

			// Always enable radios marked available
			if (!isUnavailableByDataset) {
				radio.disabled = false;
			}
			if (!radio.disabled && !isUnavailableByDataset) {
				availableRadios.push(radio);
			}
		});

		// Auto-select if exactly one available option exists
		if (qualityRadioButtons.length > 1 && availableRadios.length === 1) {
			const target = availableRadios[0];
			if (!target.checked) {
				target.checked = true;
				target.dispatchEvent(new Event("change", { bubbles: true }));
			}
		}
	}
	if (qualityTypeSelectLibrary) qualityTypeSelectLibrary.disabled = false;

	if (qualityOptionsInStockBadges) {
		qualityOptionsInStockBadges.forEach(function (badge) {
			badge.classList.remove("disabled");
		});
	}
	if (qualityOptionsOOSBadges) {
		qualityOptionsOOSBadges.forEach(function (badge) {
			badge.classList.remove("disabled");
		});
	}
}

function enableQualityDescriptionBtn() {
	if (qualityDescriptionBtnLibrary)
		qualityDescriptionBtnLibrary.disabled = false;
}

function enableFitmentSelect() {
	const fitmentRadioButtons = document.querySelectorAll(".fitment-radio");
	if (fitmentRadioButtons.length > 0) {
		fitmentRadioButtons.forEach((radio) => {
			if (radio) {
				radio.disabled = false;
			}
		});
	}
	const fitmentTexts = document.querySelectorAll(".fitmentText");
	if (fitmentTexts.length > 0) {
		fitmentTexts.forEach(function (el) {
			if (el) {
				el.classList.remove("fitment-disabled");
				el.style.color = "#000";
			}
		});
	}
	const fitmentTypeSelects = document.querySelectorAll(".fitment-type-select");
	if (fitmentTypeSelects.length > 0) {
		fitmentTypeSelects.forEach(function (el) {
			if (el) {
				el.classList.remove("fitment-disabled");
			}

			if (fitmentDescriptionContainerLibrary) {
				const firstFitmentQuestionButton = document.getElementById(
					`fitment-button-description-${el.dataset.groupIndex}`,
				);
				if (firstFitmentQuestionButton) {
					firstFitmentQuestionButton.disabled = false;
				}
			}
		});
	}
	const additionalOptionsTitle = document.querySelector(
		".additional-options-title",
	);
	if (additionalOptionsTitle) {
		additionalOptionsTitle.classList.remove(
			"additional-options-title-disabled",
		);
		additionalOptionsTitle.style.color = "#e61b24";
	}
}

function showNotCompatibleMsg(groupIndex) {
	const allMsgs = document.querySelectorAll(".not-compatible-msg");
	allMsgs.forEach((el, idx) => {
		// Find the parent group index for each message
		const parent = el.closest(".fitment-type-select");
		if (parent && parent.getAttribute("data-group-index") == groupIndex) {
			el.style.display = "block";
		} else {
			el.style.display = "none";
		}
	});
}

// function enableVINTextboxForOEM() {
// 	if (vinTextBoxOEMLibrary) vinTextBoxOEMLibrary.disabled = false;
// }

function showPaintCodeWrapper() {
	if (
		paintCodeWrapperLibrary &&
		!paintCodeWrapperLibrary.classList.contains("show")
	) {
		paintCodeWrapperLibrary.classList.add("show");
	}
}

function enableCombinedVariantSelect() {
	if (combinedVariantSelectLibrary)
		combinedVariantSelectLibrary.disabled = false;
}

function showPaintCodeAppContainer() {
	if (
		paintCodeAppContainerLibrary &&
		!paintCodeAppContainerLibrary.classList.contains("show")
	) {
		if (
			paintCodeAppContainerLicenseLibrary &&
			!paintCodeAppContainerLicenseLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLibrary.classList.add("show");
		} else {
			paintCodeAppContainerLibrary.style.display = "block";
			paintCodeAppContainerLicenseLibrary.style.display = "none";
		}
	}
}

function showPaintCodeAppContainerLicense() {
	if (
		paintCodeAppContainerLicenseLibrary &&
		!paintCodeAppContainerLicenseLibrary.classList.contains("show")
	) {
		if (
			paintCodeAppContainerLibrary &&
			!paintCodeAppContainerLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLicenseLibrary.classList.add("show");
		} else {
			paintCodeAppContainerLicenseLibrary.style.display = "block";
			paintCodeAppContainerLibrary.style.display = "none";
		}
	}
}

function enableStoredPaintCodeMsg() {
	if (storedDecodedPaintCodeMsgLibrary)
		storedDecodedPaintCodeMsgLibrary.classList.remove("disabled");
}

function enableGiveUsVinMsg() {
	if (giveUsYourVinMsgLibrary)
		giveUsYourVinMsgLibrary.classList.remove("disabled");
}

function enablePaintOptionRadioBtns() {
	if (paintOptionCheckboxByUnpainted)
		paintOptionCheckboxByUnpainted.disabled = false;
	if (paintOptionCheckboxByPaintCode)
		paintOptionCheckboxByPaintCode.disabled = false;
	if (paintOptionCheckboxByVIN) paintOptionCheckboxByVIN.disabled = false;
	if (paintOptionCheckboxByLicense)
		paintOptionCheckboxByLicense.disabled = false;
	if (paintOptionCheckboxStoredCode)
		paintOptionCheckboxStoredCode.disabled = false;
	if (selectCodeFailSafeLibrary) selectCodeFailSafeLibrary.disabled = false;
	if (paintOptionFakeCheckbox) paintOptionFakeCheckbox.disabled = false;
}

function showGetPaintCodeUsingVINCheckbox() {
	if (checkboxGetPaintCodeWithVINAndLabel)
		checkboxGetPaintCodeWithVINAndLabel.style.display = "block";
}

function showPaintedStockKeyPaintDisclaimer() {
	if (paintedStockKeyPaintLevelLibrary)
		paintedStockKeyPaintLevelLibrary.style.display = "block";
}

function showPaintedStockKeyQualityDisclaimer(message) {
	if (paintedStockKeyQualityLevelLibrary) {
		paintedStockKeyQualityLevelLibrary.style.display = "block";
		paintedStockKeyQualityLevelLibrary.innerHTML = message;
	}
}

function enablePaintedStockKeyQualityDisclaimer() {
	if (paintedStockKeyQualityLevelLibrary)
		paintedStockKeyQualityLevelLibrary.classList.remove("disabled");
}

function showVinMessageParagraph() {
	// const vinMessageParagraphLibrary = document.querySelector(
	// 	".vin-decoder-message"
	// );
	const vinMessageParagraphLibrary = document.querySelector(
		'[class^="vin-decoder-message"]:not([style*="display: none"])',
	);

	if (vinMessageParagraphLibrary) {
		vinMessageParagraphLibrary.style.display = "block";
	}
}

function showLicenseMessageParagraph() {
	const licenseMessageParagraphLibrary = document.querySelector(
		".license-decoder-message",
	);

	if (licenseMessageParagraphLibrary) {
		licenseMessageParagraphLibrary.style.display = "block";
	}
}

function enablehowToFindPaintCodeBtn() {
	enableStoredPaintCodeMsg();
	enableGiveUsVinMsg();
	enablePaintOptionRadioBtns();
	if (howToFindPaintCodeBtnLibrary)
		howToFindPaintCodeBtnLibrary.disabled = false;
}

function enableGetPaintCodeUsingVin() {
	if (getPaintCodeUsingVinLibrary) getPaintCodeUsingVinLibrary.disabled = false;
}

function showColorPreviewContainer() {
	if (
		colorPreviewContainerLibrary &&
		!colorPreviewContainerLibrary.classList.contains("show")
	)
		colorPreviewContainerLibrary.classList.add("show");
}

function enableSelectVinVariantBtn() {
	if (selectVinVariantButtonLibrary)
		selectVinVariantButtonLibrary.disabled = false;
}

function enablePrecisionMatchBtns() {
	if (precisionMatchContainerLibrary)
		precisionMatchCheckboxYes.disabled = false;
	if (precisionMatchContainerLibrary) precisionMatchCheckboxNo.disabled = false;
	if (precisionMatchButton) precisionMatchButton.disabled = false;
}

function enableVinVerificationBtns() {
	if (vinVerifyCheckbboxYesLibrary)
		vinVerifyCheckbboxYesLibrary.disabled = false;
	if (vinVerifyCheckboxNoLibrary) vinVerifyCheckboxNoLibrary.disabled = false;
	if (vinVerificationButtonLibrary)
		vinVerificationButtonLibrary.disabled = false;
	if (!finalVinVerificationSubmissionVin) {
		if (vinVerificationInput) vinVerificationInput.disabled = false;
	}
}

function showOOSPaintVariantsMsg() {
	const oemUncertaintyLibrary = document.querySelector(".oem-uncertainty");
	if (
		oemUncertaintyLibrary &&
		!oemUncertaintyLibrary.classList.contains("show")
	)
		oemUncertaintyLibrary.classList.add("show");
	// if the add to cart btn is enabled, disable it
	if (currentAddToCartBtnLibrary && !currentAddToCartBtnLibrary.disabled) {
		currentAddToCartBtnLibrary.disabled = true;
	}
}

function showVinInputAfterSelection() {
	// if (vinAfterSelection && !vinAfterSelection.classList.contains("show")) {
	// 	vinAfterSelection.classList.add("show");
	// }
	const vinElements = getVisibleVinDecoderElements();
	if (vinElements) {
		if (
			vinElements.vinAfterSelection &&
			!vinElements.vinAfterSelection.classList.contains("show")
		) {
			vinElements.vinAfterSelection.classList.add("show");
		}
	}

	// if the add to cart btn is enabled, disable it
	if (currentAddToCartBtnLibrary && !currentAddToCartBtnLibrary.disabled) {
		currentAddToCartBtnLibrary.disabled = true;
	}
}

function showFitmentVerificationComponent() {
	const vinGuaranteeContainer = document.querySelector(
		".vin-guarantee-container",
	);
	if (
		vinGuaranteeContainer &&
		vinGuaranteeContainer.classList.contains("hide")
	) {
		vinGuaranteeContainer.classList.remove("hide");
	}
}

function showVinVerificationTextbox() {
	if (vinVerificationWrapper) vinVerificationWrapper.classList.add("show");
}

function showAddToCartButton() {
	if (currentAddToCartBtnLibrary)
		currentAddToCartBtnLibrary.style.display = "block";
}

function enableAddToCartButton() {
	// Check if a quality is selected and if it's available
	const selectedQuality = document.querySelector(
		'input[name="quality_type"]:checked',
	);
	const isQualityAvailable = selectedQuality
		? selectedQuality.getAttribute("data-available") === "true"
		: true;

	// Block if selected quality is out of stock OR if base product is blocked AND no quality selected
	if (!isQualityAvailable || (window.blockAddToCart && !selectedQuality)) {
		if (currentAddToCartBtnLibrary)
			currentAddToCartBtnLibrary.dataset.awaitingAssembly = "";
		disableAddToCartButton();
		return;
	}

	// Block if assembly options are visible but none selected
	const bundleEl = document.getElementById("bundle-options");
	if (
		bundleEl &&
		bundleEl.style.display !== "none" &&
		!document.querySelector('input[name="bundle_mode"]:checked')
	) {
		if (currentAddToCartBtnLibrary)
			currentAddToCartBtnLibrary.dataset.awaitingAssembly = "1";
		disableAddToCartButton();
		return;
	}

	if (currentAddToCartBtnLibrary)
		currentAddToCartBtnLibrary.dataset.awaitingAssembly = "";
	if (currentAddToCartBtnLibrary) {
		currentAddToCartBtnLibrary.disabled = false;
		currentAddToCartBtnLibrary.classList.remove("disabled-oos");
	}
	if (addToCartStickyLibrary) {
		addToCartStickyLibrary.disabled = false;
		addToCartStickyLibrary.classList.remove("disabled-oos");
	}
}
// Enable or Disable
// finalVinVerificationSubmissionVin: This is the VIN that is submitted for verification, if it exists.
function enableOrDisableAddToCartForOEM(finalVinVerificationOrBanned) {
	if (!vinDecoderJustUsed) {
		if (
			(selectedProductType === "oem" || isOnlyOEM) &&
			finalVinVerificationOrBanned === ""
		) {
			disableAddToCartButton();
		} else {
			enableAddToCartButton();
		}
	} else if (
		// TODO: need to think about if this should show up the VIN INPUT instead
		vinDecoderJustUsed &&
		finalVinVerificationOrBanned === "ISBANNED"
	) {
		disableAddToCartButton();
	} else {
		enableAddToCartButton();
	}
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                         Fitment Questions                                          **
 **                                                                                                    **
 *******************************************************************************************************/

// Utility function to enable or disable a fitment group and update all related classes/styles
function setFitmentGroupState(group, enabled, keyIndex) {
	if (!group) return;
	const optionsContainer = group.querySelector(".fitment-options-container");
	const title = group.querySelector(".option-title-fitment");
	const button = document.getElementById(
		`fitment-button-description-${keyIndex}`,
	);
	if (enabled) {
		group.classList.remove("fitment-disabled");
		if (optionsContainer) optionsContainer.classList.remove("fitment-disabled");
		if (title) title.classList.remove("individual-fitment-title-disabled");
		if (button && Number(keyIndex) !== 0) button.disabled = false;
		group.querySelectorAll(".fitment-option").forEach(function (option) {
			const label = option.querySelector("label");
			if (label) label.classList.remove("individual-fitment-label-disabled");
			const input = option.querySelector('input[type="radio"]');
			if (input) {
				input.classList.remove("individual-fitment-select-disabled");
				input.classList.remove("fitment-disabled");
				input.disabled = false;
			}
		});
	} else {
		group.classList.add("fitment-disabled");
		if (optionsContainer) optionsContainer.classList.add("fitment-disabled");
		if (title) title.classList.add("individual-fitment-title-disabled");
		if (button && Number(keyIndex) !== 0) button.disabled = true;
		group.querySelectorAll(".fitment-option").forEach(function (option) {
			const label = option.querySelector("label");
			if (label) label.classList.add("individual-fitment-label-disabled");
			const input = option.querySelector('input[type="radio"]');
			if (input) {
				input.classList.add("individual-fitment-select-disabled");
				input.classList.add("fitment-disabled");
				input.disabled = true;
			}
		});
	}
}

async function fetchFitmentQuestionContent(url, currentLocale) {
	if (!url) {
		console.error("No URL provided for fitment key modal content.");
		return;
	}

	if (currentLocale === "es") {
		let parts = url.split(".com/");

		if (parts.length === 2) {
			url = `${parts[0]}.com/es/${parts[1]}`;
		}
	}

	try {
		const response = await fetch(`${url}.json`);
		if (!response.ok) {
			throw new Error("Failed to fetch content");
		}
		const data = await response.json();
		return data.page.body_html; // Assuming the content is in the body_html of the page
	} catch (error) {
		const accordion = document.getElementById("fitment-accordion");
		if (accordion) {
			accordion.style.display = "none";
		}
		console.error("Fetch error:", error);
	}
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                       Quality Options                                              **
 **                                                                                                    **
 *******************************************************************************************************/

function handleQualityLevelPrePaintMsg(
	STOCK_POSTFIX,
	aftermarketWord,
	andWord,
) {
	// Displays the pre-painted in stock message at quality level
	if (window.enablePrepaintedMessaging) {
		if (aftermarketAvailability || capaAvailability || oemAvailability) {
			const options = [];

			if (aftermarketAvailability)
				options.push(`<strong>${aftermarketWord}</strong>`);
			if (capaAvailability) options.push("<strong>CAPA</strong>");
			if (oemAvailability) options.push("<strong>OEM</strong>");

			// Join the list properly with commas and "and"
			let optionsString = "";
			if (options.length === 1) {
				optionsString = options[0];
			} else if (options.length === 2) {
				optionsString = `${options[0]} ${andWord} ${options[1]}`;
			} else if (options.length === 3) {
				optionsString = `${options[0]}, ${options[1]}, ${andWord} ${options[2]}`;
			}

			const finalMessage = `${optionsString} ${STOCK_POSTFIX}`;
			showPaintedStockKeyQualityDisclaimer(finalMessage);
		}
	}
}

function addInStockBadgeInQualityOptions() {
	qualityOptionsLibrary.forEach((button) => {
		const quality = button.getAttribute("data-value");
		const isInStock = handleCheckQualityAvailability(quality);

		if (isInStock) {
			// Create the new element
			const badge = createInStockBadge();

			// Insert before the .quality-option-labels element
			const labels = button.querySelector(".quality-option-labels");
			if (labels) {
				button.insertBefore(badge, labels);
			}
		}
	});
}

function addInStockBadgeInPaintOptions() {
	addedBadgeInPaintOptions = true;
	paintOptionsIndividualButtonsLibrary.forEach((button) => {
		// Create the new element
		const badge = createInStockBadge();
		badge.classList.add("ready-paint");

		// Insert before the .quality-option-labels element
		const labels = button.querySelector(".paint-option-labels-wrapper");
		if (labels) {
			button.insertBefore(badge, labels);
		}
	});
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                         Paint Options                                              **
 **                                                                                                    **
 *******************************************************************************************************/

function togglePaintedStockKey(selectedType, hasAvailableOptions) {
	if (!paintedStockKeyPaintLevelLibrary) return false;

	if (hasAvailableOptions[selectedType]) {
		selectedOptionHasAvailableStock = true;
	} else {
		selectedOptionHasAvailableStock = false;
	}
}

async function populateVariantDropdown(
	selectedType,
	disabledFirstOptionTranslation,
) {
	const combinedVariantSelect = document.getElementById("variant-selector");
	if (combinedVariantSelect) {
		combinedVariantSelect.innerHTML = `<option value="" disabled selected>${disabledFirstOptionTranslation}</option>`;
	}

	if (combinedVariantSelect) {
		clearCombinedVariantSelect(); // Reset to first option (Select Paint Code)
		disableAddToCartButton();
	}

	// Get the relevant variants for selected product type
	let variants = productVariants[selectedType] || [];

	if (variants.length === 0) {
		if (productVariants.single) {
			// If no variants for the selected type, use the single variant
			variants = productVariants.single;
		} else {
			variants = productVariants.current || [];
		}
	}

	const variantsUpdateEvent = new CustomEvent("variantsUpdated", {
		detail: { variants },
	});
	document.dispatchEvent(variantsUpdateEvent);

	if (variants.length > 0) {
		if (combinedVariantSelect) {
			enableCombinedVariantSelect();
			updateProgressHeaderColors();
		}
		enablehowToFindPaintCodeBtn();
		enableGetPaintCodeUsingVin();
		enableSelectVinVariantBtn();

		variants.forEach(function (variant) {
			let isVariantAvailable = true;

			// set it to true in the following because it is actually checking to see if the variant is hidden
			if (
				variant.variantAvailable === "true" ||
				variant.variantAvailable === true
			) {
				isVariantAvailable = false;
			} else {
				isVariantAvailable = true;
			}

			window.selectedVariantId = variant.id;
			let option;

			// Compose base label
			let optionLabel = `${variant.title}`;

			// If it has extra inventory, append the tag to the text
			if (window.enablePrepaintedMessaging) {
				if (variant.hasExtraInventory && isVariantAvailable) {
					optionLabel += " 🚚";
				}
			}

			if (boolMatchByVIN === false) {
				// Check if the variant is "Match Paint by VIN"
				if (
					variant.title.trim().startsWith("Match Paint by VIN") ||
					variant.title.trim().startsWith("Pintura de combinación por VIN")
				) {
					// Create a div instead of an option
					const div = document.createElement("div");
					div.classList.add("hidden-vin-option");

					// Copy attributes to div
					div.setAttribute("data-price", variant.price || "");
					div.setAttribute(
						"data-price-difference",
						variant.priceDifference || "",
					);
					div.setAttribute("data-color", variant.color || "");
					div.setAttribute("data-variant-title", variant.variantTitle || "");
					div.setAttribute("data-product-title", variant.productTitle || "");
					div.setAttribute("data-variant-sku", variant.variantSku || "");

					// Set text content
					div.dataset.value = variant.id || "";
					div.textContent = variant.title;
					div.style.display = "none";

					// Append div after select
					combinedVariantSelect.insertAdjacentElement("afterend", div);
					return;
				} else {
					// Create an option normally
					option = document.createElement("option");
					option.value = variant.id;

					if (!isVariantAvailable) {
						amountOfOOSPaintVariants++;
						option.dataset.unavailable = "true";
					} else {
						option.dataset.unavailable = "false";
					}

					option.textContent = optionLabel;
					option.dataset.price = variant.price;
					option.dataset.color = variant.color;
					option.dataset.variantTitle = variant.variantTitle;
					option.dataset.priceDifference = variant.priceDifference;
					option.dataset.productTitle = variant.productTitle;
					option.dataset.variantSku = variant.variantSku;
				}
			} else {
				option = document.createElement("option");
				option.value = variant.id;

				if (!isVariantAvailable) {
					amountOfOOSPaintVariants++;
					option.dataset.unavailable = "true";
				} else {
					option.dataset.unavailable = "false";
				}

				option.textContent = optionLabel;
				option.dataset.price = variant.price;
				option.dataset.color = variant.color;
				option.dataset.priceDifference = variant.priceDifference;
				option.dataset.productTitle = variant.productTitle;
				option.dataset.variantSku = variant.variantSku;
			}

			if (failedVinDecode === true) {
				option.style.display = "block";
			}

			let currentProductTitle = variant.productTitle || "";
			if (currentProductTitle.length === 0) {
				currentProductTitle = variant.name;
			}

			if (currentProductTitle.length > 0) {
				const productTitle = decodeHtmlEntities(variant.productTitle);
				if (selectedType !== "oem") {
					titleElementLibrary.textContent = productTitle;
				}
				if (productTitle.includes("CAPA")) {
					const oemImg = document.getElementById("oem-badge");
					if (oemImg) {
						oemImg.remove();
					}
					const capaImgId = document.getElementById("capa-certified-badge");
					if (!capaImgId) {
						const capaImg = document.createElement("img");
						capaImg.src =
							"https://cdn.shopify.com/s/files/1/0248/6291/6693/files/Capa_Certified_Icon_26a22ba1-e72d-4724-a44d-e73fbf1f0d2d.png";
						capaImg.alt = "CAPA Certified";
						capaImg.id = "capa-certified-badge";

						capaImg.style.position = "relative";
						capaImg.style.height = "34px";
						capaImg.style.margin = "0 0 0 10px";

						if (window.innerWidth > 720) {
							priceContainerLargeScreen.appendChild(capaImg);
						} else {
							priceContainerSmallScreen.appendChild(capaImg);
						}
					}
				} else {
					if (!productTitle.includes("OEM")) {
						const capaImg = document.getElementById("capa-certified-badge");
						if (capaImg) {
							capaImg.remove();
						}
						const oemImg = document.getElementById("oem-badge");
						if (oemImg) {
							oemImg.remove();
						}
					}
				}
			}

			// Optionally add class to selected item or add tooltip
			if (variant.hasExtraInventory) {
				option.dataset.status = "ready-to-ship";
				option.title = "Ready to ship"; // Tooltip when hovering
			}
			const tempElement = document.createElement("div");
			tempElement.innerHTML = variant.productDescription;
			if (productPartDescriptionLibrary) {
				productPartDescriptionLibrary.innerHTML = tempElement.innerHTML;
			}
			if (combinedVariantSelect) {
				combinedVariantSelect.appendChild(option);
			}
		});
	} else {
		if (combinedVariantSelect) {
			disableCombinedVariantSelect();
			clearCombinedVariantSelect();
			disableAddToCartButton();
			updateProgressHeaderColors();
		}
		disablehowToFindPaintCodeBtn();
		disableGetPaintCodeUsingVin();
		disableSelectVinVariantBtn();
	}
}

function decodeHtmlEntities(text) {
	const tempElement = document.createElement("textarea");
	tempElement.innerHTML = text;
	return tempElement.value;
}

function updateColorBox() {
	colorPreviewWrapper.style.display = "block";
	const selectedColor = selectedProductColor;
	const selectedTitle = selectedProductTitle;

	if (selectedColor) {
		// showColorPreviewContainer();
		colorBox.style.backgroundColor = selectedColor;
		colorPreviewTitle.style.visibility = "visible";
		colorBox.style.display = "block";
		colorSkeleton.style.display = "none";
		colorBox.setAttribute("title", `${selectedTitle} Paint Example`);
		// currentColor = selectedColor;
	} else {
		// Hide both the color preview and the skeleton if no metafield
		// hideColorPreviewContainer();
		colorPreviewTitle.style.visibility = "hidden";
		colorBox.style.display = "none";
		colorSkeleton.style.display = "block";
		colorBox.removeAttribute("title");
	}
}

// function to check paint code availabilty and toggle VIN input between required and optional
function handlePaintCodeAvailability(
	selectedOption,
	requiredLabelText,
	optionalLabelText,
	isOnlyOEM,
	isExcludedMake,
) {
	// If on a product page where not quality options are present but the product itself is OEM, always make VIN required unless
	// it is Unpainted
	// If OEM is selected and the paint option selected is not "Unpainted", always make VIN required
	if (
		(isOnlyOEM &&
			selectedOption.dataset.variantTitle !== "Unpainted" &&
			selectedOption.dataset.variantTitle !== "Match Paint by VIN") ||
		(selectedProductType === "oem" &&
			selectedOption.dataset.variantTitle !== "Unpainted" &&
			selectedOption.dataset.variantTitle !== "Match Paint by VIN")
	) {
		selectedVariantUnavailable = true;
	} else {
		selectedVariantUnavailable = selectedOption.dataset.unavailable === "true";
	}

	const vinElements = getVisibleVinDecoderElements();
	if (vinElements) {
		const optionalSpan = vinElements?.vinAfterSelection.querySelector(
			".vin-after-paint-code-optional",
		);

		if (selectedVariantUnavailable) {
			if (vinElements.input) {
				vinElements.input.required = true;
			}
			if (optionalSpan) {
				optionalSpan.classList.add("required");
				optionalSpan.textContent = requiredLabelText;
			}
		} else {
			// make VIN input optional
			if (vinElements.input) {
				vinElements.input.required = false;
			}
			if (optionalSpan) {
				optionalSpan.classList.remove("required");
				optionalSpan.textContent = optionalLabelText;
			}
		}
	}
	// always show the vin input after selection
	if (!isExcludedMake) {
		showVinInputAfterSelection(1);
		showVinInputContainer(1);
	} else {
		hideVinInputAfterSelection();
		hideVinInputContainer();
	}
	hideVinInputIfVinExist();
}

// VIN REQUERED GUARD
function getCartAddForm() {
	return (
		document.querySelector('form[action^="/cart/add"]') ||
		document.querySelector('form[action*="/cart/add"]')
	);
}

function getVinInputsInCartForm() {
	const cartForm = getCartAddForm();
	if (cartForm) {
		return [...cartForm.querySelectorAll('input[name="properties[VIN]"]')];
	}
	return [...document.querySelectorAll('input[name="properties[VIN]"]')];
}

function setVinInputsForUnpainted() {
	const vins = getVinInputsInCartForm();
	vins.forEach((v) => {
		v.required = false;
		v.removeAttribute("required");
		v.disabled = true;
		v.value = "";
		if (typeof v.setCustomValidity === "function") v.setCustomValidity("");
	});
}

function setVinInputsForPainted() {
	const vins = getVinInputsInCartForm();
	vins.forEach((v) => {
		v.disabled = false;
		if (typeof v.setCustomValidity === "function") v.setCustomValidity("");
	});
}

function syncVinRequiredWithPaintOption() {
	if (checkboxUnpainted && checkboxUnpainted.checked) {
		setVinInputsForUnpainted();
	} else {
		setVinInputsForPainted();
	}
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                             UTILITIES                                              **
 **                                                                                                    **
 *******************************************************************************************************/

function createInStockBadge() {
	const badge = document.createElement("div");
	badge.classList.add("available-options");
	badge.textContent = "✓";
	return badge;
}

function hideInStockBadgeOnPaintOption() {
	if (document.querySelectorAll(".available-options")) {
		const readyBadges = document.querySelectorAll(
			".available-options.ready-paint",
		);
		readyBadges.forEach((badge) => {
			badge.style.display = "none";
		});
	}
}

function showInStockBadgeOnPaintOption() {
	if (document.querySelectorAll(".available-options")) {
		// Check for false prevents from calling the function more than once
		if (addedBadgeInPaintOptions === false) {
			// addInStockBadgeInPaintOptions();
		}
		const readyBadges = document.querySelectorAll(
			".available-options.ready-paint",
		);
		readyBadges.forEach((badge) => {
			badge.style.display = "block";
		});
	}
}

function handleCheckQualityAvailability(quality) {
	let isInStock = false;

	if (quality === "aftermarket" && aftermarketAvailability) {
		isInStock = true;
	} else if (quality === "capa" && capaAvailability) {
		isInStock = true;
	} else if (quality === "oem" && oemAvailability) {
		isInStock = true;
	}
	return isInStock;
}

function addOEMBadge() {
	const capaImg = document.getElementById("capa-certified-badge");
	if (capaImg) capaImg.remove();

	const existingOEMBadge = document.getElementById("oem-badge");
	if (existingOEMBadge) return;

	const oemImg = document.createElement("img");
	oemImg.src =
		"https://cdn.shopify.com/s/files/1/0248/6291/6693/files/OEM_Badge.png";
	oemImg.alt = "OEM Certified";
	oemImg.id = "oem-badge";
	oemImg.style.position = "relative";
	oemImg.style.height = "34px";
	oemImg.style.margin = "0 0 0 10px";

	if (window.innerWidth > 720) {
		priceContainerLargeScreen.appendChild(oemImg);
	} else {
		priceContainerSmallScreen.appendChild(oemImg);
	}
}

function addCAPABadge() {
	const oemImg = document.getElementById("oem-badge");
	if (oemImg) oemImg.remove();

	const existingCapaBadge = document.getElementById("capa-certified-badge");
	if (existingCapaBadge) return;

	const capaImg = document.createElement("img");
	capaImg.src =
		"https://cdn.shopify.com/s/files/1/0248/6291/6693/files/Capa_Certified_Icon_26a22ba1-e72d-4724-a44d-e73fbf1f0d2d.png";
	capaImg.alt = "CAPA Certified";
	capaImg.id = "capa-certified-badge";
	capaImg.style.position = "relative";
	capaImg.style.height = "34px";
	capaImg.style.margin = "0 0 0 10px";

	if (window.innerWidth > 720) {
		priceContainerLargeScreen.appendChild(capaImg);
	} else {
		priceContainerSmallScreen.appendChild(capaImg);
	}
}

function removeBadges() {
	const oemImg = document.getElementById("oem-badge");
	if (oemImg) oemImg.remove();
	const capaImg = document.getElementById("capa-certified-badge");
	if (capaImg) capaImg.remove();
}

function calculatePrice(inputElement) {
	let price;

	if (inputElement.tagName === "SELECT") {
		const selectedOption = inputElement.options[inputElement.selectedIndex];
		price = selectedOption.getAttribute("data-price");
	} else if (inputElement.type === "radio") {
		// Find the checked radio in the group
		const checkedRadio = document.querySelector(
			'input[name="quality_type"]:checked',
		);
		if (!checkedRadio) return;
		price = checkedRadio.getAttribute("data-price");
	} else {
		console.warn("Unsupported element passed to calculatePrice:", inputElement);
		return;
	}

	if (!price) return;

	if (price.trim().startsWith("$")) {
		document.getElementById("price-display").innerText = price;
		document.getElementById("price-display-small-screen").innerText = price;
		document.getElementById("price-display-sticky").innerText = price;
		document.getElementById("price-display-a2c").innerText = price;
		return;
	}

	const formattedPrice = formatPriceToUSD(price);

	document.getElementById("price-display").innerText = formattedPrice;
	document.getElementById("price-display-small-screen").innerText =
		formattedPrice;
	document.getElementById("price-display-sticky").innerText = formattedPrice;
	document.getElementById("price-display-a2c").innerText = formattedPrice;
}

function formatPriceToUSD(price) {
	if (!price) return;

	if (price.trim().startsWith("$")) {
		return price;
	}

	if (!price.trim().startsWith("$")) {
		return "$" + price;
	}

	const formattedPrice = (price / 100).toFixed(2);
	return "$" + formattedPrice;
}

// Initialize auto-selection on page load
function autoSelectSingleQualityVariant() {
	const autoSelectData = document.getElementById("auto-select-variant-data");
	if (!autoSelectData) return;

	const variantId = autoSelectData.getAttribute("data-variant-id");
	const scenario = autoSelectData.getAttribute("data-scenario");

	if (!variantId) {
		console.warn("Auto-select variant data found but no variant ID specified");
		return;
	}

	const form = document.getElementById("product-form");
	if (!form) {
		console.error("Product form not found");
		return;
	}

	let hiddenInput = document.getElementById("product-form-variant-id");
	if (!hiddenInput) {
		hiddenInput = document.createElement("input");
		hiddenInput.type = "hidden";
		hiddenInput.name = "id";
		hiddenInput.id = "product-form-variant-id";
		form.appendChild(hiddenInput);
	}
	hiddenInput.value = variantId;
	window.selectedVariantId = variantId;

	console.log(`Auto-selecting variant for ${scenario}:`, variantId);
}
document.addEventListener("DOMContentLoaded", autoSelectSingleQualityVariant);

function updateOrderOfVinandLicense() {
	// No need to change order if only one option is available
	if (!paintOptionCheckboxByLicense) return;
	if (!paintOptionCheckboxByVIN) return;

	if (paintOptionCheckboxByVIN) {
		if (paintOptionCheckboxByVIN.checked) {
			// Set VIN text to full
			vinLabel.querySelector(".vin-text").textContent = paintOptionMsgFindByVin;
			licenseLabel.querySelector(".license-text").textContent =
				paintOptionMsgShortFindByLicense;
			// Move VIN before License
			licenseLabel.parentNode.insertBefore(vinLabel, licenseLabel);
			vinLabel.appendChild(separator);
			// auto add cursor to the input box.
			// document
			// 	.getElementById("vin-decoder-textbox-for-verification-wrapper")
			// 	.classList.add("show");
			// document
			// 	.getElementById("vin-decoder-textbox-for-verification")
			// 	.focus();
			const vinElements = getVisibleVinDecoderElements();
			if (vinElements) {
				if (vinElements.input) {
					vinElements.input.focus();
				}
			}
		} else {
			// reset VIN text
			vinLabel.querySelector(".vin-text").textContent =
				paintOptionMsgShortFindByVin;
			licenseLabel.querySelector(".license-text").textContent =
				paintOptionMsgFindByLicense;

			vinLabel.parentNode.insertBefore(licenseLabel, vinLabel);

			//separator after license
			licenseLabel.appendChild(separator);
			// auto add cursor to the dropdown
			// document.getElementById("license-decoder-state-select").focus();
			document
				.getElementById("license-decoder-textbox-for-verification-wrapper")
				.classList.add("show");
		}
	}
}

function setupVinSync() {
	// consider the VIN input from OEM
	// const vinInputOEM = document.getElementById("vin-textbox-for-oem");
	// push the VIN into add-to-cart form
	// if the car already has the VIN from garage, just skip.
	// const vinAfterSelectionInput = document.getElementById(
	// 	"vin-after-paint-code-textbox"
	// );

	// let searchTerms = getSearchTerms();
	// if (searchTerms[0].vin) return;

	const terms = getSearchTerms?.() || [];
	const storedVin = terms[0]?.vin ? (terms[0]?.vin).trim().toUpperCase() : "";

	// if (activeCar.vin) return;
	const forms = document.querySelectorAll('form[action^="/cart/add"]');
	if (!forms.length) return;
	forms.forEach((form) => {
		// Canonical hidden input
		let main = form.querySelector('input[name="properties[VIN]"]');
		if (!main) {
			main = document.createElement("input");
			main.type = "hidden";
			main.name = "properties[VIN]";
			form.appendChild(main);
		}

		const sync = () => {
			const vinElements = getVisibleVinDecoderElements();
			const activeVinInput = vinElements ? vinElements.input : null;

			const typed = activeVinInput
				? activeVinInput.value.trim().toUpperCase()
				: "";
			// const finalVin = typed;
			const finalVin = typed || storedVin;
			// Get value from the dropdown/selection input (the one that triggered the event)
			// const vinAfterSelectionValue = vinAfterSelectionInput.value || "";

			// Get value from the OEM textbox
			// vinInputOEM defined above
			// const vinTextboxValue = vinInputOEM ? vinInputOEM.value : "";

			// use whichever has value
			// let finalVin = "";
			// if (vinAfterSelectionValue.trim()) {
			// 	finalVin = vinAfterSelectionValue.trim().toUpperCase();
			// }

			main.value = finalVin;
			if (typed) {
				localStorage.setItem("final car vin", finalVin);
				const st = window.getSearchTerms?.() || [];
				if (st[0]) {
					st[0].vin = finalVin;
					window.setSearchTerms?.(st, 7);
					window.GarageLogic?.updateGaragePopup(st);
				}
			}
		};
		// Attach listener to all potential VIN inputs
		const allVinInputs = document.querySelectorAll(
			'[id^="vin-decoder-textbox-for-verification-"]',
		);
		allVinInputs.forEach((input) => {
			input.addEventListener("input", sync);
		});
		// vinAfterSelectionInput?.addEventListener("input", sync);

		sync();
		form.addEventListener(
			"submit",
			() => {
				// keep only ONE VIN (uppercase) in the submission
				sync();
				// disable other uppercase duplicates
				form.querySelectorAll('input[name="properties[VIN]"]').forEach((el) => {
					if (el !== main) el.disabled = true;
				});
				// disable legacy 'Vin' so it isn't posted, but leave it in the DOM for any pre-submit code
				form.querySelectorAll('input[name="properties[Vin]"]').forEach((el) => {
					el.disabled = true;
				});
			},
			{ capture: true },
		);
	});
}

// adam
// Keep VIN validation aligned with the current paint option
if (checkboxUnpainted) {
	checkboxUnpainted.addEventListener("change", syncVinRequiredWithPaintOption);
}
if (checkboxPaintOptions) {
	checkboxPaintOptions.addEventListener(
		"change",
		syncVinRequiredWithPaintOption,
	);
}
if (combinedVariantSelectLibrary) {
	combinedVariantSelectLibrary.addEventListener(
		"change",
		syncVinRequiredWithPaintOption,
	);
}
if (form) {
	form.addEventListener("submit", syncVinRequiredWithPaintOption, true);
}

// Run once on load
syncVinRequiredWithPaintOption();

/*******************************************************************************************************
 **                                                                                                    **
 **                                             UTILITIES                                              **
 **                                                                                                    **
 *******************************************************************************************************/

function hideShopifyChat() {
	const shopifyChat = document.getElementById("shopify-chat");
	if (shopifyChat) {
		shopifyChat.style.display = "none";
	}
}

function showShopifyChat() {
	const shopifyChat = document.getElementById("shopify-chat");
	if (shopifyChat) {
		shopifyChat.style.display = "block";
	}
}

// New function to handle button state
function evaluateAddToCartButtonState(location) {
	const vinAfterSelectionInput = document.getElementById(
		"vin-decoder-textbox-for-verification-after",
	);
	const vinInputValue = (vinAfterSelectionInput?.value || "").toUpperCase();
	const filteredValue = vinInputValue.replace(
		/[IOQ\s:;()!@#$%^?'"&*\-_=+.`~<>{}\[\]|,\/\\]/gi,
		"",
	);
	const isVinValidAndVariantAvailable =
		filteredValue.length === 17 || filteredValue.length === 0;
	// const isVinValidAndVariantAvailable = filteredValue.length === 0;
	const isVinValidAndVariantUnavailable = filteredValue.length === 17;

	// if vin is valid and variant is available, enable add to cart
	if (isVinValidAndVariantAvailable && !selectedVariantUnavailable) {
		enableAddToCartButton();
		// if vin is valid and variant is unavailable, enable add to cart only if a vin of 17 characters has been entered
	} else if (isVinValidAndVariantUnavailable && selectedVariantUnavailable) {
		enableAddToCartButton();
	} else {
		disableAddToCartButton();
	}
	// Update progress header colors
	updateProgressHeaderColors();
}

// new feature to display modal for mismatch or redirect
function toggleCollectionRedirectModal(
	event,
	vin,
	groupIndex,
	inclusionCountry,
	exclusionChars,
	exclusionCountry,
	isCallFromVinInput,
	translations = {},
	currentLocale,
) {
	const modal = document.querySelector(".incompatibility-modal-container");
	const overlay = document.querySelector(".incompatibility-modal-overlay");
	const isFirstVinCharInExclusion = exclusionChars.includes(vin[0]);
	document.body.classList.add("no-scroll");

	// Use translations or fallback to English
	const t = {
		vin_starts_with: translations.vin_starts_with || "Your VIN starts with",
		license_plate_indicates:
			translations.license_plate_indicates || "Your license plate indicates a",
		indicates_a: translations.indicates_a || "which indicates a",
		made: translations.made || "made",
		vehicle: translations.vehicle || "vehicle",
		product: translations.product || "product",
		product_is_not_compatible:
			translations.product_is_not_compatible ||
			"This does not match your previously selected",
		the_vin_you_entered_is_not_compatible:
			translations.the_vin_you_entered_is_not_compatible ||
			"The VIN you entered is not compatible with this product.",
		the_vehicle_identified_from_your_license_plate_is_not_compatible:
			translations.the_vehicle_identified_from_your_license_plate_is_not_compatible ||
			"The vehicle identified from your license plate is not compatible with this product.",
	};

	let modalTextContent = "";
	if (modal) modal.style.display = "block";
	if (overlay) overlay.style.display = "block";

	// text content in modal
	if (isFirstVinCharInExclusion) {
		if (isCallFromVinInput) {
			modalTextContent = `
			${t.vin_starts_with}
			<span class="modal-content">${vin[0]}</span>, 
			${t.indicates_a}
			<span class="modal-content">${exclusionCountry}-${t.made}</span> ${t.vehicle}.
			<br>
			${t.product_is_not_compatible}
			<span class="modal-content">${inclusionCountry}-${t.made}</span> ${t.product}.
		`;
		} else {
			modalTextContent = `
			${t.license_plate_indicates}
			<span class="modal-content">${exclusionCountry}-${t.made}</span> ${t.vehicle}.
			<br>
			${t.product_is_not_compatible}
			<span class="modal-content">${inclusionCountry}-${t.made}</span> ${t.product}.
		`;
		}
	} else {
		if (isCallFromVinInput) {
			modalTextContent = t.the_vin_you_entered_is_not_compatible;
		} else {
			modalTextContent =
				t.the_vehicle_identified_from_your_license_plate_is_not_compatible;
		}
	}

	document.getElementById(`incompatibility-details`).innerHTML =
		modalTextContent;

	// Apply styles to modal-content spans
	document.querySelectorAll(".modal-content").forEach((span) => {
		span.style.fontWeight = "bold";
		span.style.color = "red";
		span.style.lineHeight = "1.3";
	});
	// Button actions, remove existing event aovid the stacking
	const backBtn = document.getElementById(`incompatibility-back-btn`);
	const continueBtn = document.getElementById(`incompatibility-continue-btn`);

	// Remove existing listeners if any
	const newBackBtn = backBtn.cloneNode(true);
	backBtn.parentNode.replaceChild(newBackBtn, backBtn);
	newBackBtn.addEventListener("click", function () {
		document.body.classList.remove("no-scroll");
		if (modal) modal.style.display = "none";
		if (overlay) overlay.style.display = "none";

		let vinInput = null;
		if (isCallFromVinInput) {
			event.preventDefault();
			if (event.target && event.target.value !== undefined) {
				event.target.value = "";
			}
			// vinInput = document.getElementById(
			// 	"vin-decoder-textbox-for-verification"
			// );
			// both vin input need this
			const vinElements = getVisibleVinDecoderElements();
			if (vinElements) {
				if (vinElements.input) {
					vinElements.input.value = "";
					// vinElements.focus();
				}
				if (vinElements.submitBtn) {
					vinElements.submitBtn.disabled = true;
				}
			}

			// if (vinInput) {
			// 	vinInput.value = "";
			// 	vinInput.focus();
			// }
			// //const vinSubmitBtn = document.querySelector(".vin-decoder-submit-btn");
			// const vinSubmitBtn = document.querySelector(
			// 	'.vin-decoder-submit-btn:not([style*="display: none"])'
			// );

			// if (vinSubmitBtn) {
			// 	vinSubmitBtn.disabled = true;
			// }
		} else {
			const stateSelect = document.getElementById(
				"license-decoder-state-select",
			);
			const licenseDecoderPlateInput = document.getElementById(
				"license-decoder-plate-input",
			);
			const licenseDecoderSubmitBtn = document.querySelector(
				".license-decoder-submit-btn",
			);
			if (stateSelect) {
				stateSelect.selectedIndex = 0;
			}
			if (licenseDecoderPlateInput) {
				licenseDecoderPlateInput.value = "";
			}
			if (licenseDecoderSubmitBtn) {
				licenseDecoderSubmitBtn.disabled = true;
			}
		}
	});

	const newContinueBtn = continueBtn.cloneNode(true);
	continueBtn.parentNode.replaceChild(newContinueBtn, continueBtn);
	newContinueBtn.addEventListener("click", function (event) {
		event.preventDefault();
		window.scrollTo(0, scrollPosition);

		// Find and properly trigger the selected radio button's change event
		const selectedRadio =
			document.querySelectorAll(
				`.fitment-options-container[data-group-index="${groupIndex}"] input[type="radio"]`,
			)[1] || null;
		const vehicle = generateCollectionHandle(garageFirstVehicleData);

		const baseUrl =
			currentLocale === "en"
				? `/collections/${vehicle}/products/`
				: `/es/collections/${vehicle}/products/`;
		// if the first vin char in exclusion, navigate to the correct filtered page
		if (isFirstVinCharInExclusion) {
			if (selectedRadio) {
				// Force the change event to fire to populate answers correctly
				selectedRadio.dispatchEvent(new Event("change", { bubbles: true }));

				// Small delay to ensure the change event processing completes
				setTimeout(() => {
					const groupButton = document.querySelector(
						`[data-group-index="${groupIndex}"] button`,
					);
					if (groupButton) {
						groupButton.click();
					}
				}, 10);
			}
		} else {
			// if the 1st vin char is not in exclusion, navigate to product page without filter
			window.location.href = baseUrl;
		}

		if (modal) modal.style.display = "none";
		document.body.classList.remove("no-scroll");
	});
}
